import axios from "axios";
import {API_URL} from "src/config";
import {authApi} from "src/api/auth";
import api from "../index";

let token = await authApi.getToken()

class ClaimService {

    getClaimOverview = async (filter) => {
        try {
            let response = await api.get(`/claimOverview`).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api getClaimOverview", error);
            throw error;
        }

    };

    getListClaim = async (param) => {
        try {
            let response = await api.get(`/claimList?${param}`).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api getListClaim", error);
            throw error;
        }

    };
    getListClaimDetail = async (id, type) => {
        try {
            let response = await api.get(`/formdetail/${id}?type=${type}`).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api getListClaimDetail", error);
            throw error;
        }
    };
    getCallNotifyNo = async (claim_no) => {
        try {
            let response = await api.get(`/callnotify?claim_no=${claim_no}`).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api getCallNotifyNo", error);
            throw error;
        }
    };
    createClaim = async (data) => {
        try {
            let response = await api.post(`/createClaim`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api createClaim", error);
            throw error;
        }

    };
    editClaim = async (id, data, type) => {
        try {
            let response = await api.put(`/formdetail/${id}?type=${type ?? 'callcenter'}`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api editClaim", error);
            throw error;
        }
    };
    cancelClaim = async (id, data) => {
        try {
            let response = await api.post(`/claim/cancel/${id}`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api cancelClaim", error);
            throw error;
        }
    };

    downloadXML = async (param) => {
        // FIXME
        try {
            let response = await api.get(`/claimList?${param}`).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api downloadXML", error);
            throw error;
        }
    };

    // FIXME post with body
    // dispatchJob = async ({caseID, surveyor}) => {
    //     let response = await axios.post(API_URL + `/dispatch?caseID=${caseID}&surveyorID=${surveyor}`, token).then((res) => res.data);
    //     return {
    //         response,
    //     }
    // };
    dispatchJob = async (data) => {
        try {
            let response = await api.post(`/dispatch`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api dispatchJob", error);
            throw error;
        }
    };
    check_confirmcase = async (data) => {
        try {
            let response = await api.post(`/check_confirmcase`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api check_confirmcase", error);
            throw error;
        }

    };


    getImageClaim = async (caseID) => {
        try {
            let response = await api.get(`/getimage/${caseID}`).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api getImageClaim", error);
            throw error;
        }

    };
    uploadImage = async (data) => {
        try {
            let response = await api.post(`/uploadimage`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api uploadImage", error);
            throw error;
        }

    };
    getDataByImage = async (data) => {
        try {
            let response = await api.post(`/getDataByImage`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api uploadImage", error);
            throw error;
        }

    };
    removeImage = async (data) => {
        try {
            let response = await api.post(`/deleteimage`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api removeImage", error);
            throw error;
        }
    };

    saveCallLog = async (data) => {
        try {
            let response = await api.post(`/saveCallLog`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api saveCallLog", error);
            throw error;
        }

    };
    stampArrive = async (data) => {
        try {
            let response = await api.post(`/stampArrive`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api stampArrive", error);
            throw error;
        }

    };
    closeCRM = async (data) => {
        try {
            let response = await api.post(`/closeCRM`,data).then((res) => res.data);
            return {
                response,
            }
        } catch (error) {
            console.error("Error fetching api closeCRM", error);
            throw error;
        }
    };




}

export const claimService = new ClaimService()
